module.exports = __webpack_public_path__ + "static/media/Pete Pomilio Headshot.afe2692d.jpeg";